import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import {AuthProvider} from './context';
import {AdminRoute, CustomerRoute} from './routing';
import {
  Customer,
  Login,
  DashboardAdmin,
  DashboardCustomer,
  NewCustomer,
  PageNotFound,
  ResetPassword,
  Service,
} from './pages';

import './styles';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Switch>
          <Route exact path="/connexion" component={Login} />
          <Route
            exact
            path="/finalisation-du-compte/:resetToken"
            component={ResetPassword}
          />
          <Route
            exact
            path="/modification-du-mot-de-passe/:resetToken"
            component={ResetPassword}
          />
          <AdminRoute exact path="/admin" component={DashboardAdmin} />
          <AdminRoute exact path="/admin/nouveau-client" component={NewCustomer} />
          <AdminRoute exact path="/admin/entreprise/:id" component={Customer} />
          <CustomerRoute exact path="/" component={DashboardCustomer} />
          <CustomerRoute exact path="/service/:id" component={Service} />
          <Route path="/*" component={PageNotFound} />
        </Switch>
      </AuthProvider>
    </Router>
  );
};

export default App;
